import { useEffect, useRef } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

export default function LoginPage() {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth0();
    const navigate = useNavigate();
    const { search } = useLocation();
    const startedRef = useRef(false);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/case-list');
            return;
        }

        const params = new URLSearchParams(search);
        if (params.has("code") || params.has("state")) return;

        if (!isLoading && !startedRef.current) {
            startedRef.current = true;
            loginWithRedirect({
                authorizationParams: {
                    connection: "sms",
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "phone openid profile sms read:cases offline_access",
                },
                appState: { returnTo: "/case-list" },
            });
        }
    }, [isAuthenticated, isLoading, loginWithRedirect, search, navigate]);

    return (
        <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", textAlign: "center", px: 2 }}>
            <div>
                <CircularProgress />
                <Typography sx={{ mt: 2 }}>Redirecting to secure login…</Typography>
            </div>
        </Box>
    );
}
